(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxSearchQueryConditionBoolean', {
		bindings: {
			condition: '<',
			operators: '<',
		},
		controller: MxSearchQueryConditionBooleanCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-search-query-condition/by-type/mx-search-query-condition-boolean.html',
	});

	MxSearchQueryConditionBooleanCtrl.$inject = ['$scope'];

	function MxSearchQueryConditionBooleanCtrl($scope) {
		var vm = this;

		vm.$onInit = function () {
			if (vm.condition) {
				if (!Array.isArray(vm.condition.value) || !vm.condition.value.length) {
					vm.condition.value = [false];
				} else if (vm.condition.value.length) {
					vm.condition.value = [vm.condition.value[0].toString().toLowerCase() === 'true'];
				}
				vm.condition.operator = vm.operators.Equals.value;
			}
		};

		var w = $scope.$watch('vm.condition.value[0]', updateConditionValidity);
		$scope.$on('$destroy', () => w());
		return vm;

		function updateConditionValidity() {
			var values = vm.condition.value;
			const stateMode = vm.condition.operator === vm.operators.IsNotSet.value || vm.condition.operator === vm.operators.IsSet.value;

			vm.condition.__valid = stateMode || values[0].toString().length > 0;
		}
	}
})();
